var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lightbulb",
    clipPath: "url(#clip0_2502_9074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00065 14.0007C6.00065 14.3673 6.30065 14.6673 6.66732 14.6673H9.33398C9.70065 14.6673 10.0007 14.3673 10.0007 14.0007V13.334H6.00065V14.0007ZM8.00065 1.33398C5.42732 1.33398 3.33398 3.42732 3.33398 6.00065C3.33398 7.58732 4.12732 8.98065 5.33398 9.82732V11.334C5.33398 11.7007 5.63398 12.0007 6.00065 12.0007H10.0007C10.3673 12.0007 10.6673 11.7007 10.6673 11.334V9.82732C11.874 8.98065 12.6673 7.58732 12.6673 6.00065C12.6673 3.42732 10.574 1.33398 8.00065 1.33398ZM9.90065 8.73398L9.33398 9.13398V10.6673H6.66732V9.13398L6.10065 8.73398C5.20065 8.10732 4.66732 7.08732 4.66732 6.00065C4.66732 4.16065 6.16065 2.66732 8.00065 2.66732C9.84065 2.66732 11.334 4.16065 11.334 6.00065C11.334 7.08732 10.8007 8.10732 9.90065 8.73398Z",
    fill: "#111113"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2502_9074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.e68095a6f04d8d8076c1a9bad0fc9f6d.svg";
export { ForwardRef as ReactComponent };